import { getAuthAxiosBackend } from "../helpers/axios"

class PostServices{

    constructor(){
    }

    get(id){
        return getAuthAxiosBackend().get( 'posts' + '/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('posts', {params: data})
    }

    add(post){
        return getAuthAxiosBackend().post('posts', post)
    }

    edit(id, post){
        post.append('_method', 'put')
        return getAuthAxiosBackend().post('posts' + '/' + id, post)
    }

    delete(id){
        return getAuthAxiosBackend().delete('posts' + '/' + id)
    }
}

export default new PostServices()